import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { firstValueFrom, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ConhecimentoTransporteService } from '../../../services/conhecimento-transporte.service';
import { EstadosService } from '../../../services/estados.service';
import { MessageService } from '../../../services/message.service';
import { UnidadesEmpresaService } from '../../../services/unidades-empresa.service';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';

@Component({
  selector: 'app-importar-cte',
  templateUrl: './importar-cte.component.html',
  styleUrls: ['./importar-cte.component.css']
})
export class ImportarCteComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modalCadastro', { static: true }) modalCadastro;
  @ViewChild('abrirModal', { static: true }) abrirModal;

  constructor(
    private messageService: MessageService,
    private cteService: ConhecimentoTransporteService,
    private unidadeEmpresaService: UnidadesEmpresaService,
    private estadoService: EstadosService,
  ) {
    super();
  }

  maximoArquivos = 100;
  semCertificado = false;
  certificadoVencido = false;
  modalSubscription: Subscription;
  loading = false;
  private filesControl = new FormControl(null,
    [
      FileUploadValidators.filesLimit(this.maximoArquivos),
      FileUploadValidators.accept(['.xml'])
    ]);

  public cadastroForm = new FormGroup({
    files: this.filesControl,
  });

  erros = [];

  ngOnInit() {
  }

  show() {
    this.modalCadastro.show();
    this.verificaCertificadoDigital();
  }

  async importarNotas() {
    this.validaForm();
    const arquivos = this.cadastroForm.get('files');

    if (this.hasErrors(arquivos)) {
      return;
    }

    const erros = [];
    this.messageService.wait('Importando CT-e', 9999 * 100);
    this.loading = true;
    for (const file of arquivos.value) {
      const input = new FormData();
      input.append(file.name, file);
      try {
        await firstValueFrom(this.cteService.importarXmlCteProprio(input));
      } catch (err) {
        erros.push(err.error.errors ? err.error.errors[0] : err.msg.errors[0]);
      }
    }
    this.loading = false;
    
    this.erros = erros;
    this.messageService.clearAll();
    if (erros.length === 0) {
      this.messageService.success('Importação concluída!', 5000);
      this.closed.emit();
      this.modalCadastro.hide();
    }
  }

  hasErrors(arquivos): boolean {
    if (!arquivos.value) {
      this.messageService.error('Selecione pelo menos 1 arquivo!', 5000);
      return true;
    }

    if (arquivos.errors) {
      if (arquivos.errors.fileTypes) {
        this.messageService.error('Tipo de arquivo inválido!', 5000, '', false);
      } else if (arquivos.errors.filesLimit) {
        this.messageService.error('O máximo de arquivos é ' + this.maximoArquivos + '!', 5000, '', false);
      }
      return true;
    }
    return false;
  }

  arquivosImportados() {
    const quantidade = this.cadastroForm.get('files').value === null ? 0 : this.cadastroForm.get('files').value.length;
    return quantidade + ' / ' + this.maximoArquivos;
  }

  verificaCertificadoDigital() {
    this.unidadeEmpresaService.getCertificado()
      .pipe(finalize(() => this.alteraLoading(false)))
      .subscribe(res => {
        this.semCertificado = res == null ? true : false;
        if (res) {
          const dataValidade = new Date(res.validade);
          this.estadoService.getDateFuso().toPromise()
            .then(dataServidor => {
              if (dataValidade < new Date(dataServidor)) {
                this.certificadoVencido = true;
              }
            });
        }
      });
  }

  abrirCertificadoDigital() {
    const sub = this.abrirModal.closed.subscribe(() => {
      sub.unsubscribe();
      this.verificaCertificadoDigital();
    });

    this.abrirModal.abrir('certificadoDigital');
  }
}
